import '@fontsource/outfit/400.css';
import '@fontsource/outfit/700.css';
import '@fontsource/outfit/800.css';
import './App.css';
import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Browse from './pages/Browse';
import Audit from './pages/Audit';
import Stockroom from './pages/Stockroom';
import Duplicates from './pages/Duplicates';
import Prices from './pages/Prices';
import Orders from './pages/Orders';
import Upload from './pages/Upload';
import PartOut from './pages/PartOut';
import Skipped from './pages/Skipped';
import History from './pages/History';
import Stocking from './pages/Stocking';
import Add from './pages/Add';
import QuickAdd from './pages/QuickAdd';
import Finances from './pages/Finances';
import RemarkScanner from './pages/RemarkScanner';
import QuickLookup from './pages/QuickLookup';

function App() {
  const [authed, setAuthed] = useState(
    localStorage.getItem('ba_auth') === 'true'
  );

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />;
  }

  return (
    <BrowserRouter>
      <div style={{ fontFamily: "'Outfit', sans-serif" }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/stockroom" element={<Stockroom />} />
          <Route path="/dupes" element={<Duplicates />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/partout" element={<PartOut />} />
          <Route path="/skipped" element={<Skipped />} />
          <Route path="/history" element={<History />} />
          <Route path="/add" element={<Add />} />
          <Route path="/quickadd" element={<QuickAdd />} />
          <Route path="/finances" element={<Finances />} />
          <Route path="/stocking" element={<Stocking />} />
          <Route path="/remarks" element={<RemarkScanner />} />
          <Route path="/lookup" element={<QuickLookup />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;